/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Contact_HeadingInputs */

const en_marketing_contact_heading = /** @type {(inputs: Marketing_Contact_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One email reaches the engineer.`)
};

const es_marketing_contact_heading = /** @type {(inputs: Marketing_Contact_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un solo correo llega al ingeniero.`)
};

const fr_marketing_contact_heading = /** @type {(inputs: Marketing_Contact_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un seul e-mail atteint l'ingénieur.`)
};

/**
* | output |
* | --- |
* | "One email reaches the engineer." |
*
* @param {Marketing_Contact_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_contact_heading = /** @type {((inputs?: Marketing_Contact_HeadingInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Contact_HeadingInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_contact_heading(inputs)
	if (locale === "es") return es_marketing_contact_heading(inputs)
	return fr_marketing_contact_heading(inputs)
});